import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import type { StoreFieldsActions } from '@atlassian/jira-software-backlog/src/common/hooks/use-store-fields/types.tsx';
import { refreshUIFBacklogData } from '@atlassian/jira-software-uif-early-script';
import { fetchPlanData } from '../../rest/fetch-plan-data';
import type { SetAppDataPayload } from '../../state/actions/app';
import type { EpicIssueTypeState } from '../../state/reducers/config/epic/types';
import { transformPlanData } from './transformers';

interface LoadClassicRestDataParams {
	boardId: string;
	isCompanyManaged: boolean;
	activeQuickFilters?: Array<string>;
	epicIssueType: EpicIssueTypeState | null;
	storeFieldsActions?: StoreFieldsActions | null;
}

export function loadPlanDataService({
	boardId,
	isCompanyManaged,
	activeQuickFilters,
	epicIssueType,
	storeFieldsActions,
}: LoadClassicRestDataParams): ObservableType<SetAppDataPayload> {
	return fetchPlanData({
		rapidViewId: boardId,
		activeQuickFilters,
		operation: 'fetchBacklogData',
	}).map((data) => {
		if (storeFieldsActions?.storeFieldsFromPrefetchedPlanData) {
			storeFieldsActions.storeFieldsFromPrefetchedPlanData(data, epicIssueType);
		}

		refreshUIFBacklogData(Number(boardId), data);
		return transformPlanData(data, isCompanyManaged, activeQuickFilters);
	});
}
